// Version can come from multiple sources in order of precedence
const APP_VERSION = window.APP_VERSION || 
                   process.env.REACT_APP_VERSION || 
                   '0.1.0-' + Date.now().toString().slice(-6);

export const getAppVersion = () => APP_VERSION;

// For debugging in development
if (process.env.NODE_ENV !== 'production') {
  console.log('App Version:', APP_VERSION);
}

export default APP_VERSION;